import React, { useContext, useMemo } from 'react';
import Brand from '../../../layout/Brand/Brand';
import Navigation from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { dashboardPagesMenu } from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import { usePermission, ROUTER_KEYS } from '../../../contexts/permissionContext';

// 路由权限映射：所有业务菜单统一使用 PAGE_VIEW 权限
const MENU_ROUTER_MAP: Record<string, string> = {
  tagManagement: ROUTER_KEYS.PAGE_VIEW,
  audienceManagement: ROUTER_KEYS.PAGE_VIEW,
};

const DefaultAside = () => {
  const { asideStatus, setAsideStatus } = useContext(ThemeContext);
  const { canAccessRouter, loading, isUserAdmin } = usePermission();

  // 根据权限过滤菜单项
  const filteredMenu = useMemo(() => {
    // 管理员显示全部菜单
    if (isUserAdmin) {
      return dashboardPagesMenu;
    }

    // 权限加载中时显示全部菜单（避免闪烁）
    if (loading) {
      return dashboardPagesMenu;
    }

    // 根据权限过滤
    const filtered: Record<string, typeof dashboardPagesMenu[keyof typeof dashboardPagesMenu]> = {};

    Object.entries(dashboardPagesMenu).forEach(([key, menuItem]) => {
      const routerKey = MENU_ROUTER_MAP[key];
      // 没有配置权限映射的菜单项默认显示
      if (!routerKey || canAccessRouter(routerKey)) {
        filtered[key] = menuItem;
      }
    });

    return filtered;
  }, [canAccessRouter, loading, isUserAdmin]);

  return (
    <Aside>
      <AsideHead>
        <Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
      </AsideHead>
      <AsideBody>
        <Navigation menu={filteredMenu} id='aside-dashboard' />
      </AsideBody>
      <AsideFoot>
        <User />
      </AsideFoot>
    </Aside>
  );
};

export default DefaultAside;
